import script from './component-lib.esm2.js';
import normalizeComponent from '../../external/vue-runtime-helpers/dist/component-lib.esm.js';
import createInjector from '../../external/vue-runtime-helpers/dist/inject-style/component-lib.esm.js';

/* script */
const __vue_script__ = script;

/* template */
var __vue_render__ = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _vm.banners.length ? _c('ProfileLinkWrapper', {
    attrs: {
      "threshold": 0.25,
      "tabindex": "0",
      "aria-label": "Carousel"
    },
    on: {
      "event": _vm.handleWrapperEvent,
      "in-view": _vm.handleInView
    }
  }, [_c('div', {
    staticClass: "site-carousel",
    class: _vm.classes,
    style: _vm.styles
  }, [_c('div', {
    ref: "carousel",
    staticClass: "site-carousel__slides",
    class: _vm.sliderClasses,
    style: _vm.sliderStyles,
    attrs: {
      "draggable": "false"
    }
  }, [_vm._l(_vm.banners, function (banner, i) {
    return _c('CarouselItem', _vm._b({
      key: banner._id.$oid,
      attrs: {
        "id": "carousel-" + _vm.id + "-" + i,
        "banner": banner,
        "index": i,
        "current-index": _vm.index,
        "is-shown": i === _vm.index,
        "aria-label": "slide " + (i + 1) + " of " + _vm.numberOfBanners,
        "width": _vm.bannerWidthPercent,
        "enable-utm-parameters": _vm.enableUtmParameters,
        "utm-medium": _vm.utmMedium,
        "utm-source": _vm.utmSource
      },
      on: {
        "click": _vm.handleBannerClick,
        "image-loaded": _vm.handleImageLoaded,
        "event": function ($event) {
          return _vm.$emit('event', $event);
        },
        "focus": function ($event) {
          return _vm.handleBannerFocus(i);
        }
      }
    }, 'CarouselItem', _vm.$props, false));
  }), _vm._v(" "), _vm.playSwipeAnimation && !_vm.isInAdmin ? _c('div', {
    ref: "swipeWrapper",
    staticClass: "site-carousel__swipe",
    on: {
      "animationend": _vm.hideSwipeIcon
    }
  }, [_c('GestureSwipeIcon')], 1) : _vm._e()], 2), _vm._v(" "), _c('nav', {
    ref: "nav",
    staticClass: "site-carousel__nav",
    attrs: {
      "aria-label": "carousel navigation"
    }
  }, [!_vm.bannerOptions.hide_arrows && _vm.numberOfBanners > 1 ? [_c('span', {
    staticClass: "site-carousel__nav__left"
  }, [_c('IconButton', {
    staticClass: "site-carousel__nav__arrow",
    attrs: {
      "disabled": _vm.index <= 0,
      "aria-label": "previous slide",
      "color": _vm.btnBgColor,
      "filled": _vm.profile.site_carousel_arrows_style === 'filled',
      "size": "2.5rem"
    },
    on: {
      "click": function ($event) {
        return _vm.goTo(_vm.index - 1);
      }
    }
  }, [_c('ChevronIcon', {
    attrs: {
      "direction": "left"
    }
  })], 1)], 1), _vm._v(" "), _c('span', {
    staticClass: "site-carousel__nav__right"
  }, [_c('IconButton', {
    staticClass: "site-carousel__nav__arrow",
    attrs: {
      "aria-label": "next slide",
      "disabled": _vm.index >= _vm.numberOfBanners - 1,
      "color": _vm.btnBgColor,
      "filled": _vm.profile.site_carousel_arrows_style === 'filled',
      "size": "2.5rem"
    },
    on: {
      "click": function ($event) {
        return _vm.goTo(_vm.index + 1);
      }
    }
  }, [_c('ChevronIcon', {
    attrs: {
      "direction": "right"
    }
  })], 1)], 1)] : _vm._e(), _vm._v(" "), !_vm.bannerOptions.hide_dots && _vm.numberOfBanners > 1 ? _c('div', {
    staticClass: "site-carousel__nav__items"
  }, _vm._l(_vm.numberOfBanners, function (i) {
    return _c('a', {
      key: "nav" + i,
      staticClass: "site-carousel__nav__item",
      class: {
        'site-carousel__nav__item--active': i - 1 === _vm.index
      },
      attrs: {
        "href": "#carousel-" + _vm.id + "-" + i
      },
      on: {
        "click": function ($event) {
          $event.preventDefault();
          return _vm.handleNavClick(i - 1);
        }
      }
    }, [_c('span', {
      class: {
        'sr-only': !_vm.profile.site_carousel_dots_style
      }
    }, [_vm._v("\n            " + _vm._s(i) + "\n          ")])]);
  }), 0) : _vm._e()], 2)])]) : _vm._e();
};
var __vue_staticRenderFns__ = [];

/* style */
const __vue_inject_styles__ = function (inject) {
  if (!inject) return;
  inject("data-v-2ff259fa_0", {
    source: ".site-carousel{text-align:center;position:relative}.site-carousel__slides{display:flex;margin:0 -.25rem;user-select:none;touch-action:pan-y;transition:all .5s;-webkit-tap-highlight-color:transparent}.site-carousel__slides.no-trans{transition:none}.site-carousel__swipe{color:rgba(255,255,255,.7);display:inline-flex;font-size:6rem;position:absolute;top:50%;left:50%;transform:translate(-50%,-50%);pointer-events:none}.site-carousel--has-interacted .site-carousel__swipe{display:none}.site-carousel__swipe svg{animation:swipe-x 1.75s ease-in-out backwards;animation-iteration-count:2;filter:drop-shadow(0 0 .25rem rgba(0, 0, 0, .4))}@keyframes swipe-x{0%{transform:translateX(0)}25%{transform:translateX(50px) rotateZ(10deg)}50%{transform:translateX(0)}75%{transform:translateX(-50px) rotateZ(-10deg)}}.site-carousel__item{display:flex;flex-shrink:0;padding-left:.25rem;padding-right:.25rem;transition:all .5s;width:100%}.site-carousel__item--no-trans{transition:none}.site-carousel__item--muted{opacity:.4}.site-carousel__item--hidden{opacity:0;pointer-events:none}.site-carousel__item.loaded .site-carousel__item__link{opacity:1}.site-carousel__item.loaded .site-carousel__item__loader{opacity:0;visibility:hidden}.site-carousel__item .site-carousel__item__loader{top:50%;left:50%;position:absolute;transform:translate(-50%,-50%)}.site-carousel__item__inner{background:var(--g-color-gray-200);border-radius:var(--p-btn-border-radius);border-radius:min(var(--p-btn-border-radius),10px);box-shadow:var(--p-btn-box-shadow);position:relative;overflow:hidden;width:100%}.site-carousel__item__inner img{border-radius:inherit;height:100%;object-fit:cover;width:100%;position:absolute;left:0;top:0}.site-carousel__item__link{background-position:center;background-repeat:no-repeat;background-size:cover;border-radius:inherit;display:block;padding-bottom:var(--c-height-ratio);opacity:0;transition:all .3s}.site-carousel__nav__left,.site-carousel__nav__right{position:absolute;top:calc(50% - var(--c-nav-height)/ 2);transform:translateY(-50%)}.site-carousel__nav__arrow{padding:.25rem!important}.site-carousel__nav__arrow:disabled{cursor:default;opacity:.2!important}.site-carousel__nav__left{left:.25rem}.site-carousel__nav__right{right:.25rem}.site-carousel__nav__items{display:inline-flex;align-items:center;gap:.75rem;padding-top:calc(1rem + var(--p-btn-box-shadow-size));padding-bottom:.5rem;flex-wrap:wrap;justify-content:center}.site-carousel__nav__item{background:var(--c-nav-bg-color);color:var(--c-nav-color);border-radius:50%;height:.85rem;width:.85rem;display:inline-flex;align-items:center;justify-content:center;position:relative;opacity:.65;transition:all var(--g-transition-speed);text-decoration:none;font-family:var(--p-font-family);font-size:.9rem;line-height:1}.site-carousel__nav__item span{display:block}.site-carousel--dots-numbers .site-carousel__nav__item{height:1.75rem;width:1.75rem}.site-carousel__nav__item--active,.site-carousel__nav__item:focus,.site-carousel__nav__item:hover{opacity:1}.site-carousel__nav__item:before{content:\"\";position:absolute;height:175%;width:175%;top:50%;left:50%;transform:translate(-50%,-50%)}",
    map: undefined,
    media: undefined
  });
};
/* scoped */
const __vue_scope_id__ = undefined;
/* module identifier */
const __vue_module_identifier__ = undefined;
/* functional template */
const __vue_is_functional_template__ = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__ = /*#__PURE__*/normalizeComponent({
  render: __vue_render__,
  staticRenderFns: __vue_staticRenderFns__
}, __vue_inject_styles__, __vue_script__, __vue_scope_id__, __vue_is_functional_template__, __vue_module_identifier__, false, createInjector, undefined, undefined);
var ProfileCarousel = __vue_component__;
export { ProfileCarousel as default };